module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo15-0cc2b638c1bcdea665efe0344010ce20.jpg";